// plugins/parallax.client.ts
import type {
  ObjectDirective,
  DirectiveBinding,
  DirectiveHook,
  App,
} from "@vue/runtime-core";

interface HTMLElementWithParallaxer extends HTMLElement {
  _parallaxerInstance?: any;
}

const mounted: DirectiveHook = async (
  el: HTMLElementWithParallaxer,
  binding: DirectiveBinding
) => {
  const { default: Parallaxer } = await import("~/lib/parallaxer");

  let speed = 1;
  let mobileSpeed = 1;
  let toOrigin = false;

  if (binding.value && typeof binding.value === "object") {
    speed = binding.value.speed ?? speed;
    mobileSpeed = binding.value.mobileSpeed ?? mobileSpeed;
    toOrigin = binding.value.toOrigin ?? toOrigin;
  }

  const parallaxer = new Parallaxer();
  parallaxer.registerElement(el, speed, mobileSpeed, toOrigin);

  el._parallaxerInstance = parallaxer;
};

const unmounted: DirectiveHook = (
  el: HTMLElementWithParallaxer,
  _binding: DirectiveBinding
) => {
  el._parallaxerInstance?.unregisterElement?.(el);
};

const directive: ObjectDirective = {
  mounted,
  unmounted,
  getSSRProps: () => ({}),
};

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.directive("parallax", directive);
});
